/* eslint-disable react/jsx-props-no-spreading */
import { useCallback, useMemo } from "react"; // Removed useState as useQuery handles it
import PropTypes from "prop-types";
import useGetTagsList from "hookQueries/useGetTagsList";
import Select from "components/common/Select";
import useEvent from "hooks/useEvent";
import useRouterSearchParams from "hooks/useRouterSearchParams";
import transformOptions from "./transformOptions";
import STYLES from "./index.css";

const DELIMITER = "|||";

export default function TagsSelectFilter({ ...props }) {
  const [searchParams, setSearchParams] = useRouterSearchParams();

  const { data, isFetching } = useGetTagsList();
  const dataValues = useMemo(
    () => searchParams.get("tags")?.split(DELIMITER) || [],
    [searchParams],
  );

  const options = useMemo(() => {
    const rawTags = data || [];
    return transformOptions(rawTags);
  }, [data]);

  const selected = useMemo(
    () => options.filter((opt) => dataValues.includes(opt.value?.toString())),
    [options, dataValues],
  );

  const handleChange = useEvent((selectedOptions) => {
    const params = new URLSearchParams(searchParams);
    if (selectedOptions?.length) {
      params.set("tags", selectedOptions.map((o) => o.value).join(DELIMITER));
      params.set("tagsNames", selectedOptions.map((o) => o.label).join(DELIMITER));
    } else {
      params.delete("tags");
      params.delete("tagsNames");
    }
    setSearchParams(params);
  });

  const loadOptions = useCallback(
    async (search) => {
      if (!search) return options;
      return options.filter((opt) => opt.label.toLowerCase().includes(search.toLowerCase()));
    },
    [options],
  );

  return (
    <Select
      key={isFetching ? "fetching" : "idle"}
      placeholder="Select"
      label="Tags"
      variant="outlined"
      size="lg"
      styles={STYLES}
      selectComponent="asyncSelect"
      defaultOptions
      isMulti
      isSearchable
      value={selected}
      onChange={handleChange}
      loadOptions={loadOptions}
      cacheUniqs={[options, isFetching]}
      {...props}
    />
  );
}

TagsSelectFilter.propTypes = {
  filterName: PropTypes.string,
};
